var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,5.37375 18.62625,0 12,0 C5.37375,0 0,5.37375 0,12 C0,18.62625 5.37375,24 12,24 C12.0705,24 12.141,23.9985 12.21075,23.997 L12.21075,14.65575 L9.633,14.65575 L9.633,11.65125 L12.21075,11.65125 L12.21075,9.44025 C12.21075,6.876 13.776,5.48025 16.0635,5.48025 C17.1585,5.48025 18.1005,5.562 18.375,5.59875 L18.375,8.2785 L16.79775,8.2785 C15.55275,8.2785 15.31275,8.8695 15.31275,9.73725 L15.31275,11.65125 L18.288,11.65125 L17.90025,14.65575 L15.31275,14.65575 L15.31275,23.53575 C20.328,22.0995 24,17.478 24,12 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.86a8cd286d7658fe9eccc6443dfd61fb.svg";
export { ForwardRef as ReactComponent };